import * as React from "react";
import { SVGProps } from "react";
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 30H5a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2ZM18.866 7.232l2.598 1.5-1 1.731-2.598-1.5 1-1.73v-.001Zm-5.902 16.222-2.598-1.5 6.5-11.258 2.598 1.5-6.5 11.258ZM8.665 27.9a1 1 0 0 0 .97.017l4.164-2.214a.995.995 0 0 0 .397-.383l9.5-16.454A1.002 1.002 0 0 0 23.33 7.5L19 5a.998.998 0 0 0-1.366.366l-9.5 16.454c-.094.162-.14.348-.134.535l.165 4.714c.012.302.157.58.393.76l.107.071Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEdit;
